import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";
import BoxTypesConfigurations from "@/components/logistics/box-types/box-types-configurations";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/box-types",
)({
  component: BoxTypesPage,
});

function BoxTypesPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "box_types", actions: ["read", "update"] }]}
    >
      <BoxTypesConfigurations />
    </RouteGuardPermissions>
  );
}
